import { render, staticRenderFns } from "./BreadCrumbsRouter.vue?vue&type=template&id=f35e5f92&"
import script from "./BreadCrumbsRouter.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumbsRouter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports